<script>
	import 'app.css';
</script>

<main>
    <div class="frosting"></div>
    <div class='content'>
        <section>
			<img src='/images/logo-buffalo-minified.png' alt='Buffalo Logo'/> 
			<p class='big'><span class='company-name'>Roberts Global Management</span> is the international affiliate of <br>Roberts Capital Advisors, LLC.</p>

			<p class='small'>For more information on Roberts Capital Advisors, 
				please see their website <a href="https://www.robertscapital.com">here.</a></p>
		</section>
        <footer>
            <p>Copyright © 2022 Roberts Capital Advisors, LLC. All rights reserved.</p>
        </footer>
    </div>
</main>


<style>
	main {
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        width: 100%;
        height: 100%;
        min-height: 110vh;
        
        background: url('/images/layer-bkgd-minified.png') 0% 0% repeat;
        background-position: 0px 0px;
		animation: animatedBackground 500s linear infinite;
	}

    .content {
        position: relative;

        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        height: 100%;
        width: 100%;
        max-width: 700px;
        flex-grow: 1;

        /* background: lightsalmon; */
    }

	.content img {
		height: 250px;
		padding: 50px;
	}

	section {
        flex-grow: 1;
        /* padding-top: 5vh; */
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;

        /* background: lightgrey; */
    }

	section p {
        font-family: 'Patua One', monospace;  
        margin: 40px 0;
        padding: 0;
        letter-spacing: 0.03em;
        color: #223167;

        text-align: center;
    }

	.big {
		font-size: 2.5rem;
	}

	.small {
		font-size: 1.5rem;
		font-family: 'Noto Sans';  
	}

    .frosting {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        /* z-index: 1; */

        /* background: linear-gradient(117.18deg, rgba(242, 246, 255, 0.6) 12.29%, rgba(255, 255, 255, 0.85) 50.68%, rgba(242, 246, 255, 0.65) 85%); */
        background: linear-gradient(117.18deg, rgba(198, 213, 245, 0.7) 12.29%, rgba(255, 255, 255, 1) 45%, rgba(204, 216, 243, 0.7) 90%);
    }

	.company-name {
        /* color: #F69B31; */
		color: #00955F;
		/* color: #95C83E; */
    }

    footer {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		padding: 20px;

        font-size: 0.8rem;
        color: rgb(88, 88, 88);

	}

    footer p {
        margin: 0;
        padding: 0;
    }

	@media (max-width: 600px) {

		.content {
			width: 90%;
		}

		.content img {
			height: 150px;
			padding: 30px;
		}

		.big {
			font-size: 1.5rem;
		}

		.small {
			font-size: 1rem;
		}

	}

    @keyframes animatedBackground {
		0%   {background-position: 50% 0;}
		25%  {background-position: 100% 50%;}
		50%  {background-position: 50% 100%;}
		75%  {background-position: 0 50%;}
		100% {background-position: 50% 0;}
	}
</style>
